import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertToHtml'
})
export class ConvertToHtmlPipe implements PipeTransform {

    private _urlRegexGlobal: RegExp = /((www\.|(http|https|ftp|news|file)+\:\/\/)[&#95;.a-z0-9-]+\.[a-z0-9\/&#95;:_@=.+?,##%&~-]*[^.|\'|\# |!|\(|?|,| |>|<|;|\)])/gi;
    private _urlRegex: RegExp = /((www\.|(http|https|ftp|news|file)+\:\/\/)[&#95;.a-z0-9-]+\.[a-z0-9\/&#95;:_@=.+?,##%&~-]*[^.|\'|\# |!|\(|?|,| |>|<|;|\)])/i;

    transform(value: string): string {
        if (value) {
            let text = this.ConvertNewLineToBR(value);
            let finalText = this.ConvertTextToLink(text);

            return finalText;
        }
        return '';
    }

    private ConvertNewLineToBR(value: string): string {
        return value.replace(/\n/g,'<br/>');
    }

    private ConvertTextToLink(value: string): string {
        return value.replace(this._urlRegexGlobal, (match: string, capture: string) => {
                 return this.AddProtocol(match);
             });
    }

    private AddProtocol(value: string): string {
        const regexURL = this._urlRegex.exec(value);
        let protocolURL = value;
        if (regexURL && !regexURL[3]) {
            protocolURL = 'http://' + value;
        }
        return    `<a class="typography-caption text-break" href="${protocolURL}" target="_blank">${value}</a>`;
    }

}
